// src/lib/apiPromotions.js
import { api } from "./api";

export async function getMyPromotions() {
  try {
    return await api.getJson("/promotions/me/");
  } catch (error) {
    if (error?.status === 404) {
      return { results: [] };
    }
    throw error;
  }
}

export async function getPromotions({ promoCode } = {}) {
  const query = promoCode ? `?promo_code=${encodeURIComponent(promoCode)}` : "";
  return api.getJson(`/promotions/${query}`);
}
